export default "__VITE_ASSET__CdncbTnO__"